var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIco(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.94 26.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook_ico"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook_ico-2",
    "data-name": "facebook ico"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_138",
    "data-name": "Trazado 138",
    d: "M26.94,13.47a13.47,13.47,0,1,0-15.58,13.3V17.36H8v-3.9h3.43v-3c0-3.37,2-5.25,5.08-5.25a17.73,17.73,0,0,1,3,.29v3.3H17.75a2,2,0,0,0-2.21,1.71,2.8,2.8,0,0,0,0,.41v2.53h3.75l-.6,3.89H15.55v9.42a13.46,13.46,0,0,0,11.39-13.3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIco);
export default __webpack_public_path__ + "static/media/facebook_ico.45ae70259872e0157c306f43fdc25156.svg";
export { ForwardRef as ReactComponent };